<template>
	<modal
		:exibir="exibir"
		:titulo="titulo"
		:max-width="450"
		:is-confirmar-visivel="true"
		:custom-actions="false"
		:acao-confirmar="assinar"
		:nome-botao-confirmar="nomeBotaoConfirmar"
		:acao-cancelar="cancelar"
		@close="cancelar"
	>
		<template #body>
			<v-row dense class="mt-3">
				<v-col cols="12">
					<label-personalizado nome-campo="Nome"></label-personalizado>
					<v-text-field
						id="nome"
						v-model="assinante.nome"
						v-validate="'required|max:50'"
						name="Nome"
						:couter="50"
						:maxLength="50"
						type="text"
						dense
						clearable
						class="ma-0 py-0"
						placeholder="Informe o nome"
						disabled
						:error-messages="errors.collect('Nome')"
					>
					</v-text-field>
				</v-col>
				<v-col cols="12">
					<label-personalizado nome-campo="Documento"></label-personalizado>
					<span class="ma-0 py-0">{{ assinante.documento | azCpfCnpj }}</span>
				</v-col>
				<v-col cols="12" class="mt-3">
					<v-list class="ma-0 py-0">
						<span class="grey--text">Documento(s) selecionado(s):</span>
						<v-list-item
							v-for="documento in documentosSelecionados"
							:key="documento.id"
							class="content-list-emails padding-zero"
						>
							<v-list-item-content>{{ documento.titulo }}</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-col>
			</v-row>
		</template>
	</modal>
</template>
<script>
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
export default {
	name: 'modal-assinatura-eletronica-generico',
	components: { LabelPersonalizado },
	props: {
		exibir: {
			type: Boolean,
			required: true,
		},
		titulo: {
			type: String,
			required: true,
		},
		nomeBotaoConfirmar: {
			type: String,
			default: 'Salvar',
		},
	},
	data() {
		return {
			assinante: {
				nome: null,
				documento: null,
			},
		}
	},
	computed: {
		documentosSelecionados() {
			return this.$store.state.modalAssinaturaFlowbee.documentosSelecionados
		},
	},
	async mounted() {
		await this.buscarInformacoesUsuario()
	},
	methods: {
		async assinar() {
			this.$emit('assinar-eletronicamente')
			this.$emit('fechar-modal-pai')
			this.cancelar()
		},
		async buscarInformacoesUsuario() {
			this.setMensagemLoading('Iniciando serviço de assinatura...')

			const dados = await this.$store.dispatch(actionTypes.COMUM.BUSCAR_INFORMACOES_USUARIO)

			this.setDadosAssinatura(dados)
		},
		cancelar() {
			this.$emit('fechar-modal')
		},
		setDadosAssinatura(dados) {
			this.assinante.nome = dados.nome
			this.assinante.documento = dados.docChave
		},
	},
}

import { actionTypes } from '@/core/constants'
</script>
<style lang="stylus" scoped>
.padding-zero
	padding: 0 !important
</style>
